export class AnalyticsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Run a privacy-minimized analytics export over a window (S114). */
    export(query) {
        return this.client.request({ method: 'POST', path: '/v1/analytics/exports', body: query, auth: true });
    }
    getExport(exportId) {
        return this.client.request({ method: 'GET', path: `/v1/analytics/exports/${encodeURIComponent(exportId)}`, auth: true });
    }
    listExports() {
        return this.client.request({ method: 'GET', path: '/v1/analytics/exports', auth: true });
    }
}
//# sourceMappingURL=analytics.js.map